<pp-icon
  [ppSrc]="EIconPath.ICON_BADGE_INFO"
  ppColor="grey-600"
  ppHoverColor="grey-700"
  [ppClass]="ppClass"
></pp-icon>
